import { Injectable, OnInit } from '@angular/core';

import { AppService } from './app.service';

@Injectable({
  providedIn: 'root',
})
export class TextToSpeechService implements OnInit {
  constructor(private appService: AppService) {}
  ngOnInit(): void {}
  speak(text: string): void {
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    window.speechSynthesis.speak(utterance);
    utterance.addEventListener('start', () => {
      //console.log('TTS started');
      this.appService.setTTSPlaying(true);
    });
    utterance.addEventListener('end', () => {
      //console.log('TTS stopped');
      this.appService.setTTSPlaying(false);
    });
  }

  stop()
  {
    window.speechSynthesis.cancel();
    this.appService.setTTSPlaying(false);
  }
}
